import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PinAuthenticationService } from '../services/pin-authentication.service';
import { SignInService } from '../services/sign-in.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
	constructor(private pinAuthService: PinAuthenticationService,
		private signInService: SignInService) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (this.pinAuthService.isAnonUserAuthenticated) {
			request = request.clone({
				setHeaders: 
				{
					AuthorizationP: `${this.pinAuthService.currentAnonUserValue.token}`
				}
			})
		}

		if (this.signInService.isUserAuthenticated) {
			request = request.clone({
				setHeaders: 
				{
					AuthorizationA: `${this.signInService.currentAuthenticatedUserValue.token}`
				}
			})
		}

		return next.handle(request);
	}
}
